"use client";

import { Suspense } from "react";
import { PropertyDataV2, PropertyTypeV2 } from "commonModule/services/common";
import FavoriteButtonForPropertyPopOverVersion from "components/favorite-button/FavoriteButtonForPropertyPopOverVersion";
import BookmarkIcon from "components/icons-svg/BookmarkIcon";
import useFavorites from "hooks/swr/useFavorites";
import { useIsAgent } from "hooks/useIsAgent";
import { useIsTravelAgentClient } from "hooks/useIsTravelAgentClient";
import { selectIsUserLoggedIn } from "stores/auth/authSlice";
import { useAppSelector } from "stores/hooks";
import ShareButton from "./share-button";
const DetailPageActionButtons = ({
  property,
  coverImg,
  isAttachmentsGalleryModalOpen,
  variant = "default"
}: {
  property: PropertyTypeV2;
  coverImg: string;
  isMultiUnitDetailPage: boolean;
  isAttachmentsGalleryModalOpen?: boolean;
  variant?: "default" | "overlay";
}) => {
  const favPropertyIds = useFavorites();
  const isFavourite = !!favPropertyIds.find(id => id === property.property_id);
  const isAgent = useIsAgent();
  const isTravelAgentClient = useIsTravelAgentClient();
  const isLoggedIn = useAppSelector(selectIsUserLoggedIn);
  return <>
      <Suspense data-sentry-element="Suspense" data-sentry-source-file="DetailPageActionButtons.tsx">
        {isLoggedIn && <FavoriteButtonForPropertyPopOverVersion propertyId={property.property_id} isFavorited={isFavourite} propertyName={property.property_name} city={property.city} state={property.state} country={property.country} numberOfBedroom={property.no_of_bedrooms} propertyTypeDesc={property.property_type_desc} callbackWhenTriggeredWithoutLogin={() => {
        localStorage.setItem("mixpanelPageOrigin", "Property Details Page - Save to Favorite");
      }} property={((property as unknown) as PropertyDataV2)}>
            {({
          className,
          onClick,
          role
        }) => <button onClick={onClick} role={role} aria-label='save to a collection' className={`group relative m-0 flex h-8 w-8 min-w-[auto] items-center justify-center px-0 shadow-none md:h-auto md:w-auto md:gap-2 md:hover:bg-transparent ${variant === "overlay" ? "rounded-full bg-white/70 md:rounded-none md:bg-transparent" : ""} ${className || ""} after:pointer-events-auto after:absolute after:-inset-1 after:rounded-full after:bg-transparent after:content-['']`}>
                <span className='hidden whitespace-nowrap text-xs font-normal leading-[1.7] text-grayText md:inline-block'>
                  {isFavourite ? "Saved to a collection" : "Save to a collection"}
                </span>
                <BookmarkIcon className={`md:h-4 md:w-[14px] ${isFavourite ? "fill-accent-500 text-accent-500" : "fill-none md:text-Gray-600"} ${variant === "overlay" ? "text-brand-dark" : ""}`} />
              </button>}
          </FavoriteButtonForPropertyPopOverVersion>}
      </Suspense>
    </>;
};
export default DetailPageActionButtons;